const INIT = 'checkout/INIT';
const TOGGLE_ACCOUNT_CREATION = 'checkout/my-account/TOGGLE_ACCOUNT_CREATION';
const SET_CHANGED_OPT_INS = 'checkout/my-account/SET_CHANGED_OPT_INS';
const ACCOUNT_CREATE_SUCCESS = 'checkout/my-account/ACCOUNT_CREATE_SUCCESS';
const UPDATE_CART_STATE = 'checkout/cart/UPDATE_CART_STATE';
const CART_UPDATE_FAILED = 'checkout/cart/CART_UPDATE_FAILED';
const INIT_ORDER = 'checkout/order/INIT_ORDER';
const ORDER_CREATE_SUCCESS = 'checkout/order/ORDER_CREATE_SUCCESS';
const ORDER_CREATE_FAILED = 'checkout/order/ORDER_CREATE_FAILED';
const ORDER_SET = 'checkout/order/ORDER_SET';
const ORDER_CLEAR = 'checkout/order/ORDER_CLEAR';
const ORDER_GET_BY_TOKEN_SUCCESS = 'checkout/order/GET_ORDER_BY_TOKEN_SUCCESS';
const ORDER_GET_BY_TOKEN_FAILED = 'checkout/order/GET_ORDER_BY_TOKEN_FAILED';
const GET_ADDITIONAL_COSTS_SUCCESS = 'checkout/GET_ADDITIONAL_COSTS_SUCCESS';
const SET_DONATION = 'checkout/SET_DONATION';
const CLEAR_ERROR = 'checkout/error/CLEAR_ERROR';
const init = ()=>({
        type: INIT
    })
;
const updateCartState = (payload)=>({
        type: UPDATE_CART_STATE,
        payload
    })
;
const initOrder = ()=>({
        type: INIT_ORDER
    })
;
const toggleAccountCreation = (payload)=>({
        type: TOGGLE_ACCOUNT_CREATION,
        payload
    })
;
const setChangedOptIns = (payload)=>({
        type: SET_CHANGED_OPT_INS,
        payload
    })
;
const setDonation = (payload)=>({
        type: SET_DONATION,
        payload
    })
;

export { ACCOUNT_CREATE_SUCCESS, CART_UPDATE_FAILED, CLEAR_ERROR, GET_ADDITIONAL_COSTS_SUCCESS, INIT, INIT_ORDER, ORDER_CLEAR, ORDER_CREATE_FAILED, ORDER_CREATE_SUCCESS, ORDER_GET_BY_TOKEN_FAILED, ORDER_GET_BY_TOKEN_SUCCESS, ORDER_SET, SET_CHANGED_OPT_INS, SET_DONATION, TOGGLE_ACCOUNT_CREATION, UPDATE_CART_STATE, init, initOrder, setChangedOptIns, setDonation, toggleAccountCreation, updateCartState };
//# sourceMappingURL=actions.js.map
